import React, { useState, useEffect } from "react";
import axios from "axios";
import * as constants from "../constants/domains";
import qs from "qs";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";

function Register(props) {
    const [username, setUsername] = useState("");
    const [inputName, setInputName] = useState("");
    const [inputEmail, setInputEmail] = useState("");
    const [inputPassword, setInputPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [validationError, setValidationError] = useState({});

    const setCookie = useCookies(["user_server_token"])[1];
    // const setCookie = useCookies(["user_server_token"])[1];

    const { location, history } = props;

     function datalayer(username) {
        // if (typeof window !== "undefined" && typeof gtag === "function") {
        //     gtag('event', 'user_register', {
        //     username: username
        // });
    // }
    }
    
    // const datalayer = (username) => {
    //     const googleTagmanager = document.createElement("script");
    //     googleTagmanager.src = "/user/js/google_tagmanager.js";
    //     googleTagmanager.async = true;
    //     document.body.appendChild(googleTagmanager);
    //     googleTagmanager.onload = () => {
    //         window.dataLayer = window.dataLayer || [];
    //         window.dataLayer.push({
    //             event: "user_register",
    //             username: username,
    //         });
    //     };
    // };

    const formSubmit = (event) => {
        const queryParams = qs.parse(props.location.search, {
            ignoreQueryPrefix: true,
        });
        event.preventDefault();
        setLoading(true);
        axios
            .post(constants.$apiUrl + "/api/register", {
                username: username,
                name: inputName,
                email: inputEmail,
                password: inputPassword,
                addToSegment:
                    (queryParams.addToSegment == "true" ? true : false) ??
                    false,
            })
            .then((response) => {
                setLoading(false);
                datalayer(username);
                setValidationError({});
                if (response.data && response.data.success) {
                    let oneYear = Date.now() + 365 * 24 * 60 * 60 * 1000;
                    setCookie("user_server_token", response.data.data.token, {
                        domain: constants.$cookieURL,
                        path: "/",
                        expires: new Date(oneYear),
                    });

                    if (queryParams.site === "class") {
                        const callBack = queryParams.callBack
                            ? queryParams.callBack
                            : "";
                        window.location.href =
                            constants.$class_next_url + callBack;
                    } else {
                        const callBack = queryParams.callBack
                            ? queryParams.callBack
                            : "";
                        window.location.href =callBack?callBack:
                            constants.$shopUrl;
                        // window.location.href = constants.$shopUrl;
                    }
                } else {
                    toast.error(
                        "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
                        {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        },
                    );
                }
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
                if (error.response && error.response.status === 400) {
                    setValidationError({ ...error.response.data.data });
                    if (
                        error.response.data.data.username &&
                        error.response.data.data.username.length > 0
                    ) {
                        toast.error(
                            "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
                            {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            },
                        );
                    }
                } else if (error.response && error.response.status === 409) {
                    const site = queryParams.callBack ? queryParams.site : "";
                    window.location.href = constants.$apiUrl + "?site=" + site;
                } else {
                    toast.error(
                        "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
                        {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        },
                    );
                }
            });
    };

    useEffect(() => {
        const queryParams = qs.parse(location.search, {
            ignoreQueryPrefix: true,
        });

        try {
            setUsername(window.atob(queryParams["token"]));
        } catch (e) {
            history.push({
                pathname: "/user",
                search: "?site=shop",
            });
        }
    }, [location, history]);

    return (
        <React.Fragment>
            <div className="container">
                <div className="card-group card-authentication mx-auto mb-5">
                    <div className="login-card">
                        <div className="card-content direction-rtl">
                            <div className="form-header-logo">
                                <img
                                    src={
                                        constants.$authUrl +
                                        "/images/honari_logo.png"
                                    }
                                    alt="هنری دات کام"
                                />
                                <div className="logo-text">
                                    <p className="logo-honari-text">هـنـری</p>
                                    <p className="logo-desc-text">
                                        تحقق رویای هنرمندانه‌ تو
                                    </p>
                                </div>
                            </div>
                            <div className={"form-header"}>تکمیل اطلاعات</div>
                            <form onSubmit={(event) => formSubmit(event)}>
                                <div className="mb-4 row">
                                    <label
                                        htmlFor="username"
                                        className={"register-mobile-message"}
                                    >
                                        شماره همراه
                                    </label>
                                    <div className={"login-form-row"}>
                                        <input
                                            id="username"
                                            type="text"
                                            disabled={"disabled"}
                                            className={"form-field "}
                                            value={username}
                                        />
                                    </div>
                                </div>
                                <div className="mb-4 row">
                                    <label
                                        htmlFor="name"
                                        className={"register-mobile-message"}
                                    >
                                        نام و نام خانوادگی &nbsp;
                                        <span className={"text-danger"}>*</span>
                                    </label>
                                    <div className={"login-form-row"}>
                                        <input
                                            id="name"
                                            type="text"
                                            className={
                                                "form-field " +
                                                (validationError["name"] &&
                                                Array.isArray(
                                                    validationError["name"],
                                                )
                                                    ? "not-valid "
                                                    : "")
                                            }
                                            autoFocus={"auto"}
                                            onChange={(event) =>
                                                setInputName(event.target.value)
                                            }
                                            value={inputName}
                                        />
                                    </div>
                                    {validationError["name"] &&
                                    Array.isArray(validationError["name"])
                                        ? validationError["name"].map(
                                              (item, index) => {
                                                  return (
                                                      <div
                                                          className={"row"}
                                                          key={index}
                                                      >
                                                          <div
                                                              key={index}
                                                              className={
                                                                  "validation-error"
                                                              }
                                                          >
                                                              {item}
                                                          </div>
                                                      </div>
                                                  );
                                              },
                                          )
                                        : null}
                                </div>

                                <div className="mb-4 row">
                                    <label
                                        htmlFor="email"
                                        className={"register-mobile-message"}
                                    >
                                        ایمیل
                                    </label>
                                    <div className={"login-form-row"}>
                                        <input
                                            id="email"
                                            type="email"
                                            className={
                                                "form-field " +
                                                (validationError["email"] &&
                                                Array.isArray(
                                                    validationError["email"],
                                                )
                                                    ? "not-valid "
                                                    : "")
                                            }
                                            onChange={(event) =>
                                                setInputEmail(
                                                    event.target.value,
                                                )
                                            }
                                            value={inputEmail}
                                        />
                                    </div>
                                    {validationError["email"] &&
                                    Array.isArray(validationError["email"])
                                        ? validationError["email"].map(
                                              (item, index) => {
                                                  return (
                                                      <div
                                                          className={"row"}
                                                          key={index}
                                                      >
                                                          <div
                                                              key={index}
                                                              className={
                                                                  "validation-error"
                                                              }
                                                          >
                                                              {item}
                                                          </div>
                                                      </div>
                                                  );
                                              },
                                          )
                                        : null}
                                </div>

                                <div className="mb-4 row">
                                    <label
                                        htmlFor="email"
                                        className={"register-mobile-message"}
                                    >
                                        رمز عبور &nbsp;
                                        <span className={"text-danger"}>*</span>
                                    </label>
                                    <div className={"login-form-row"}>
                                        <input
                                            id="password"
                                            type="password"
                                            className={
                                                "form-field " +
                                                (validationError["password"] &&
                                                Array.isArray(
                                                    validationError["password"],
                                                )
                                                    ? "not-valid "
                                                    : "")
                                            }
                                            onChange={(event) =>
                                                setInputPassword(
                                                    event.target.value,
                                                )
                                            }
                                            value={inputPassword}
                                        />
                                    </div>

                                    {validationError["password"] &&
                                    Array.isArray(validationError["password"])
                                        ? validationError["password"].map(
                                              (item, index) => {
                                                  return (
                                                      <div
                                                          className={"row"}
                                                          key={index}
                                                      >
                                                          <div
                                                              key={index}
                                                              className={
                                                                  "validation-error"
                                                              }
                                                          >
                                                              {item}
                                                          </div>
                                                      </div>
                                                  );
                                              },
                                          )
                                        : null}
                                </div>

                                <div className="row">
                                    <div className={"my-3"}>
                                        {loading ? (
                                            <button
                                                disabled={true}
                                                className="btn btn-honari w-100 py-2"
                                            >
                                                در حال ارسال اطلاعات...
                                            </button>
                                        ) : (
                                            <button className="btn btn-honari w-100 py-2">
                                                ثبت نام
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Register;
